import { Box } from "@chakra-ui/react";

type IProps = {
  question: string;
  aText: string;
  onClick: () => void;
};

const TextNavigator = (props: IProps) => {
  return (
    <Box
      as="p"
      py={"1.4rem"}
      mt={{ base: 0, md: "2rem", lg: "0.8rem" }}
      textAlign={"center"}
      color={"whiteAlpha.800"}
    >
      {props.question}
      <Box
        onClick={props.onClick}
        as={"button"}
        border={"2px solid"}
        textDecor={"underline"}
        borderColor={"background"}
        cursor={"pointer"}
        px={".2rem"}
        fontWeight={600}
        borderRadius={".4rem"}
      >
        {props.aText}
      </Box>
    </Box>
  );
};

export default TextNavigator;
